<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} línea
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-6">
                  <label>Nombre línea<span class="required"></span></label>
                  <input type="text" id="description"
                    [ngClass]="{'parsley-error': (submitted && f['description'].errors)}" formControlName="description"
                    required="true" class="form-control" [autofocus]>
                  <div *ngIf="submitted && f['description'].errors">
                    <small class="text-danger" *ngIf="f['description'].errors['required']">Nombre es requerido</small>
                    <small class="text-danger" *ngIf="f['description'].errors['minlength']">Nombre Muy corto</small>
                  </div>
                </div>
                <div class="form-group col-lg-6">
                    <label>Categoría</label>
                    <ng-autocomplete 
                        #searchInputCategory
                        [class]='classSearch'
                        [data]="categories"
                        [initialValue]="initialCategory"
                        [searchKeyword]="'description'"
                        placeholder="Seleccionar categoría"
                        (selected)='selectSearchCategory($event)'
                        (inputCleared)='clearedSearchCategory()'                          
                        [itemTemplate]="itemTemplate"
                        [notFoundTemplate]="notFoundTemplate">                                 
                        </ng-autocomplete>
                        <ng-template #itemTemplate let-item>
                            <a style="padding: 8px 15px;" class="f-s-12 p-10" [innerHTML]="item.description"></a>
                        </ng-template>   
                        <ng-template #notFoundTemplate let-notFound>
                            <p style="padding-top: 5px;
                            margin-bottom: 5px;
                            font-weight: 500;">No se encontraron registros</p>
                        </ng-template>
                  </div>
              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
